import React from "react";
import AbstractTableContainer from "../shared/entity/components/AbstractTable/container";
import entityOptions from "./config/entity";

export default function () {
    return (
        <AbstractTableContainer
            options={entityOptions}
            isFromClient={false}
        />
    );
}
